var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClockCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1025)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 1.83337C4.59425 1.83337 1.83334 4.59428 1.83334 8.00004C1.83334 11.4058 4.59425 14.1667 8.00001 14.1667C11.4058 14.1667 14.1667 11.4058 14.1667 8.00004C14.1667 4.59428 11.4058 1.83337 8.00001 1.83337ZM0.833344 8.00004C0.833344 4.042 4.04197 0.833374 8.00001 0.833374C11.9581 0.833374 15.1667 4.042 15.1667 8.00004C15.1667 11.9581 11.9581 15.1667 8.00001 15.1667C4.04197 15.1667 0.833344 11.9581 0.833344 8.00004ZM8.00001 4.83337C8.27615 4.83337 8.50001 5.05723 8.50001 5.33337V7.79293L10.0202 9.31315C10.2155 9.50842 10.2155 9.825 10.0202 10.0203C9.82497 10.2155 9.50838 10.2155 9.31312 10.0203L7.64646 8.35359C7.55269 8.25983 7.50001 8.13265 7.50001 8.00004V5.33337C7.50001 5.05723 7.72387 4.83337 8.00001 4.83337Z",
    fill: "#596970"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockCircle);
export default __webpack_public_path__ + "static/media/icon_clock_circle.a41ff63dabf4f6f1e4ed2b719fee61a7.svg";
export { ForwardRef as ReactComponent };